// extracted by mini-css-extract-plugin
export default {"input":"Textarea_input__yQSu1","errors":"Textarea_errors__ULgHE"};